import { Checkbox } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { setRemoteWorking } from '../../../../../../redux/reducers/talentSlice'
import { remoteOptions } from '../../../../../../utils/utils'
import * as s from './Remote.styles'

const Remote = () => {
  const { t } = useTranslation(['offer'], {
    useSuspense: false,
  })

  const dispatch = useDispatch()

  const { remoteWorking } = useSelector((state) => state.talent)

  const handleRemoteTypeChange = (selectedValues) => {
    dispatch(setRemoteWorking(selectedValues))
  }

  const ContractCheckbox = ({ value, children }) => (
    <Checkbox value={value} defaultChecked>
      {children}
    </Checkbox>
  )

  return (
    <s.RemoteTypeWrapper>
      <label className="field-label">
        {t('campaign:createOffer.generalStep.remoteWorking.label')}
      </label>
      <Checkbox.Group onChange={handleRemoteTypeChange} value={remoteWorking}>
        {remoteOptions(t).map((type) => (
          <ContractCheckbox key={type.value} value={type.value}>
            {type.label}
          </ContractCheckbox>
        ))}
      </Checkbox.Group>
    </s.RemoteTypeWrapper>
  )
}

export default Remote
